import { Collapse, ConfigProvider, Divider, Flex, Skeleton } from "antd";
import { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../../utils/lang_provider";
import { fetchData, fetchImage } from "../../utils/fetch";
import SkeletonImage from "antd/es/skeleton/Image";

export default function Trainings() {
    const { language } = useContext(LanguageContext);
    const [ trainings, setTrainings ] = useState([]);
    const [ trainingsOffers, setTrainingOffers] = useState([]);
    const [ trainingsLoaded, setTrainingsLoaded] = useState(false);
    const [ trainingsOffersLoaded, setTrainingOffersLoaded] = useState(false);
    const [ content, setContent ] = useState("");

    useEffect(() => {
        async function loadContent() {
            try {
                const data = await fetchData(`front/page/${language === 'sk' ? 'skolenia' : 'trainings'}`)
                setContent(data);
            } catch (error) {
                console.error("Error loading content:", error);
            }
        }
        async function loadTrainings() {
            try {
                const data = await fetchData(`front/trainings`);
                setTrainings(data);
                setTrainingsLoaded(true);
            } catch(error) {
                console.error("Error loading trainings:", error);
            }
        }
        async function loadTrainingOffers() {
            try {
                const data = await fetchData(`front/trainings/offers`);
                setTrainingOffers(data);
                setTrainingOffersLoaded(true);
            } catch (error) {
                console.error("Error loading trainings:", error);
            }
        }
        loadContent();
        loadTrainings();
        loadTrainingOffers();
    }, [language]);

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorText: "rgb(255, 255, 255)",
                    colorBorder: "rgb(59, 36, 36)"
                },
                components: {
                    Collapse: {
                        headerBg: "rgb(114, 105, 105)",
                        contentBg: "rgb(144, 137, 137)"
                    }
                }
            }}>
            <div style={{margin: "0 10% 5% 10%"}}>
                <Divider></Divider>
                <div dangerouslySetInnerHTML={{"__html": content.content}}></div>
                <Divider></Divider>
                {/*
                <h2>{language === 'sk' ? "Nadchádzajúce Školenia" : "Upcoming Trainings"}</h2>
                <Divider></Divider>
                {trainingsLoaded ?
                    <Collapse items={
                        trainings.map(training => {
                            return {
                                key: training.id,
                                label: training.title,
                                children: <Description training={training}/>
                            }
                        }) 
                    }/>
                    :
                    <Skeleton></Skeleton>
                }
                <h2>{language === 'sk' ? "Ponuky Školení" : "Training Offers"}</h2>
                <Divider></Divider>
                {trainingsOffersLoaded ?
                    <Collapse items={
                        trainingsOffers.map(offer => {
                            return {
                                key: offer.id,
                                label: offer.title,
                                children: <OfferDescription offer={offer}/>
                            }
                        }) 
                    }/>
                    :
                    <Skeleton></Skeleton>
                }
                */}
            </div>
        </ConfigProvider>
    )
}

function Description({ training }) {
    const date = new Date(Date.parse(training.start_date));
    const start_date = date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear();
    const [ thumbnail, setThumbnail ] = useState(null);
    const { language } = useContext(LanguageContext);

    useEffect(() => {
        async function loadThumbnail() {
            try {
                const imageResponse = await fetchImage(`front/image/trainings/${training.id}/thumbnail`, language);
                const imageBlob = await imageResponse.blob();
                setThumbnail(URL.createObjectURL(imageBlob));
            } catch (error) {

            }
        }
        loadThumbnail();
    }, [training, language]);

    return (
        <Flex vertical>
            <Flex justify="space-between">
                <p style={{width: "50%"}}><div dangerouslySetInnerHTML={{"__html": training.content}}></div></p>
                {!thumbnail ? <SkeletonImage></SkeletonImage> : <img style={{maxWidth: '500px'}} src={thumbnail}></img>}
            </Flex>
            <Divider></Divider>
            <Flex justify="space-between">
                <p><b>Dátum konania: {start_date}</b></p>
                {training.start_time === null ? "" : <p><b>Čas konania: {training.start_time}</b></p>}
            </Flex>
        </Flex> 
    )
}

function OfferDescription({ offer }) {
    const [ thumbnail, setThumbnail ] = useState(null);
    const { language } = useContext(LanguageContext);

    useEffect(() => {
        async function loadThumbnail() {
            try {
                const imageResponse = await fetchImage(`front/image/trainingOffers/${offer.id}/thumbnail`, language);
                const imageBlob = await imageResponse.blob();
                setThumbnail(URL.createObjectURL(imageBlob));
            } catch (error) {

            }
        }
        loadThumbnail();
    }, [offer, language]);

    return (
        <Flex vertical>
            <Flex justify="space-between">
                <p style={{width: "50%"}}><div dangerouslySetInnerHTML={{"__html": offer.content}}></div></p>
                {!thumbnail ? <SkeletonImage></SkeletonImage> : <img style={{maxWidth: '500px'}} src={thumbnail}></img>}
            </Flex>
            <Divider></Divider>
            <Flex justify="space-between">
                <p><b>Dĺžka konania: {offer.duration} dní {"(" + offer.duration * 24 + " hodín)"}</b></p>
                <p><b>Cena: podľa dohody</b></p>
            </Flex>
        </Flex>
    )
}
